import Alpine from 'alpinejs'
import Swiper from 'swiper/bundle'

window.Swiper = Swiper

const movieSliderOptions = ($refs) => ({
  speed: 200,
  slidesPerView: 1,
  spaceBetween: 92,
  navigation: {
    nextEl: $refs.next,
    prevEl: $refs.prev,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    1280: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
  },
})


const achievementSliderOptions = ($refs) => ({
  speed: 200,
  slidesPerView: 1,
  spaceBetween: 207,
  navigation: {
    nextEl: $refs.next,
    prevEl: $refs.prev,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
})

function initScrollToTop() {
  const target = document.querySelector('#scroll-to-top-target')
  if (!target) {
    return
  }
  const scrollToTopBtn = document.querySelector('#scroll-to-top-button')

  function callback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        scrollToTopBtn.classList.add('opacity-0')
      } else {
        scrollToTopBtn.classList.remove('opacity-0')
      }
    })
  }

  let observer = new IntersectionObserver(callback)
  observer.observe(target)
}
document.addEventListener('DOMContentLoaded', initScrollToTop)

window.movieSliderOptions = movieSliderOptions
window.achievementSliderOptions = achievementSliderOptions

window.Alpine = Alpine
Alpine.start()


import { initIframeManager } from "./iframeManager";
import { initCookieConsent } from "./cookieConsent";

async function loadTranslations(lang) {
  try {
    const translations = await import(`./translations/${lang}.json`);
    return translations.default;
  } catch {
    const translations = await import("./translations/sl.json");
    return translations.default;
  }
}

document.addEventListener("DOMContentLoaded", async function () {
  const lang = document.documentElement.lang || "sl";
  const translations = await loadTranslations(lang);

  const im = initIframeManager(translations.iframeManager, lang);
  initCookieConsent(im, translations.cookieConsent, lang);
  initWidgets(document.body);
});
